import { render, staticRenderFns } from "./inputText.vue?vue&type=template&id=732f1a2b"
import script from "./inputText.vue?vue&type=script&lang=js"
export * from "./inputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports